<template>
  <div class="container">
    <div class="top-container">
      <span class="userName">用户名：{{userInfo && userInfo.realName}}</span>
      <div style="margin-right: 20px;"><el-button type="text" @click.native="loginOut">退出</el-button></div>
    </div>
    <div class="separator"></div>
    <div style="text-align: center;">
      <img src="@/assets/income.png" alt="" style="width: 60%;margin-top: 40px;" @click="incomeAction"/>
      <img src="@/assets/send.png" alt="" style="width: 60%;margin-top: 40px;" @click="sendAction"/>
	  <img src="@/assets/daifahuoicon.png" alt="" style="width: 60%;margin-top: 40px;" @click="tpProdsendAction"/>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { userLogout } from '@/api/user';

export default {
  data() {
    return {
      activeName: 'first',
      boxNo: '',
      storePosition: '',
      count: 10,
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
  },
  methods: {
    async loginOut() {
      try {
        await userLogout();
        this.$store.commit('user/removeToken');
        window.location.reload();
      } catch (e) {
        console.log(e);
      }
    },
    incomeAction() {
      this.$router.push({
        name: 'AppIncome',
      });
    },
    sendAction() {
      this.$router.push({
        name: 'AppDeliver',
      });
    },
    tpProdsendAction() {
      this.$router.push({
        name: 'AppTpProd',
      });
    },
  },

};
</script>

<style lang="less" scoped>
  .container {
    height: 100%;
    width: 100%;
    background-color: white;
  }
  .top-container {
    display: flex;
    justify-content: space-between;
    align-items:center;
    font-size: 14px;
    margin-top: 5px;
    height: 40px;
    background: #FFFFFF;
  }
  .userName {
    font-size:14px;
    color:rgba(64,64,64,1);
    margin-left: 20px;
  }
  .separator {
    width: 100%;
    height: 10px;
    background: #EEEEEE;
    display: block;
  }
</style>
